import {Button} from '@/components/ui/button/Button'
import {
    DialogDisclosure,
    DialogProvider,
    Dialog,
    DialogDismiss,
    DialogBody,
    DialogFooter
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {PencilLineIcon} from '@/components/ui/icon/Icon'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext} from '@ariakit/react'
import {useMemo} from 'react'
import {EditReferringSpecialistFormProvider} from '@/features/projects/components/project-form/edit-referring-specialist-form-provider/EditReferringSpecialistFormProvider'
import {EditReferringSpecialistFormFields} from '@/features/projects/components/project-form/edit-referring-specialist-form-fields/EditReferringSpecialistFormFields'
import {EditReferringSpecialistFormFooter} from '@/features/projects/components/project-form/edit-referring-specialist-form-footer/EditReferringSpecialistFormFooter'
import {
    ProjectDetailsDialogHeader,
    ProjectDetailsDialogHeading
} from '@/features/projects/components/project-details-dialog-atoms/ProjectDetailsDialogAtoms'

export const ReferringSpecialistEditDialog = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    return (
        <DialogProvider>
            <DialogDisclosure
                render={
                    <Button variant="ghost">
                        <PencilLineIcon />
                        {t('commons:edit')}
                    </Button>
                }
            />
            <Dialog width="800px" overflowY="unset">
                <DialogContent project={project} />
            </Dialog>
        </DialogProvider>
    )
}

const DialogContent = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    const dialogContext = useDialogContext()

    const referringSpecialistToDefaultValues = useMemo(
        () => ({
            id: project.id,
            sender: project.sender,
            specialist: project.specialist
        }),
        [project]
    )

    return (
        <>
            <ProjectDetailsDialogHeader>
                <ProjectDetailsDialogHeading>{t('projects:edit_referring_entity')}</ProjectDetailsDialogHeading>
                <DialogDismiss />
            </ProjectDetailsDialogHeader>
            <EditReferringSpecialistFormProvider defaultValues={referringSpecialistToDefaultValues}>
                <DialogBody>
                    <EditReferringSpecialistFormFields />
                </DialogBody>
                <DialogFooter>
                    <EditReferringSpecialistFormFooter onCancel={() => dialogContext?.setOpen(false)} />
                </DialogFooter>
            </EditReferringSpecialistFormProvider>
        </>
    )
}
